module.exports = __webpack_public_path__ + "static/media/debt-student-v4.a564e02f.svg";